import { scopeThreeSpendBasedCategories } from "./scopeThreeCategories";

const shippingTransportScopeThreeCategories = scopeThreeSpendBasedCategories
  .filter(
    ({ subcategory }) =>
      subcategory === "upstream-transport-distribution" ||
      subcategory === "downstream-transportation-and-distribution"
  )
  .map(({ scopeThreeCategory }) => scopeThreeCategory);

export const extractScopeThreeEmissions = (emissions) => {
  const extractScopeThreeCategory = (emission) => {
    const {
      emissionData = {},
      subcategory,
      tonsCo2e,
      scopeThreeCategory: emissionScopeThreeCategory,
      id
    } = emission;

    const { scopeThreeCategory: emissionDataScopeThreeCategory = null } =
      emissionData;

    const { subcategory: scopeThreeSubcategory } =
      scopeThreeSpendBasedCategories.find(
        (category) =>
          category.scopeThreeCategory === emissionScopeThreeCategory ||
          category.scopeThreeCategory === emissionDataScopeThreeCategory
      ) || {};

    if (scopeThreeSubcategory) {
      return {
        ...emission,
        ...emissionData,
        id, //we explicitly put the emission id here because sometimes there's an old id in emission data that makes the tranasction seem like a ghost
        tonsCo2e,
        subcategory: scopeThreeSubcategory,
        inputSubcategory: subcategory
      };
    }

    return {
      ...emission,
      ...emissionData,
      id,
      tonsCo2e,
      subcategory: "purchased-goods-services",
      inputSubcategory: subcategory
    };
  };

  return emissions.map((emission = {}) => {
    const { subcategory, emissionData, scopeThreeCategory } = emission;
    const {
      scopeThreeCategory: emissionDataScopeThreeCategory,
      id,
      ...otherProps
    } = emissionData || {};

    const isShippingWithTransportScopeThreeCategory =
      subcategory === "shipping" &&
      (shippingTransportScopeThreeCategories.includes(
        emissionDataScopeThreeCategory
      ) ||
        shippingTransportScopeThreeCategories.includes(scopeThreeCategory));

    if (
      subcategory === "spend-based" ||
      isShippingWithTransportScopeThreeCategory
    ) {
      return extractScopeThreeCategory(emission);
    }

    return {
      ...emission,
      scopeThreeCategory: scopeThreeCategory || emissionDataScopeThreeCategory,
      ...otherProps
    };
  });
};
